<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'gray',
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.skeletonContainer]: true,
      [$style.darkTheme]: theme === 'dark',
      [$style.lightGrayTheme]: theme === 'lightGray',
    }" />
</template>

<style lang="scss" module>
@import '@design';

.skeletonContainer {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  background-color: $lightest-gray;
  border-radius: 16px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    transform: translateX(-100%);
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}

.darkTheme {
  background-color: $darkest-gray !important;

  &::after {
    background-image: linear-gradient(
      90deg,
      rgba($dark-gray, 0) 0,
      rgba($dark-gray, 0.2) 20%,
      rgba($dark-gray, 0.5) 60%,
      rgba(#fff, 0)
    );
  }
}

.lightGrayTheme {
  background-color: $light-gray !important;
}
</style>
